const bookHeadingParallax = ({ el }) => {
   const header = document.querySelector('[data-header]');
   const headerHeight = header.offsetHeight;
   const screenHeight = window.innerHeight - headerHeight;
   const screenWidth = window.innerWidth;

   const spacer = el.previousElementSibling;
   const imageWindow = spacer.querySelector('[data-book-heading-parallax-image-container]');
   
   let widthDivider = 4;
   let heightDivider = 1.25;
   const endingWidth = screenWidth;
   const endingHeight = 100;
   let startingWidth = 513;
   let widthUnit = 'px';

   if (window.innerWidth < 1024) {
      widthDivider = 1.5;
      heightDivider = 1.5;
      startingWidth = 100 / widthDivider;
      widthUnit = '%';
   }

   const updateBackgroundState = () => {
      if (window.innerWidth < 768) {
         return;
      }
      const position = el.getBoundingClientRect();
      const backgroundImage = el.querySelector('[data-book-heading-parallax-background]');
      if (position.top < 97) {
         backgroundImage.classList.remove('opacity-0');
      } else {
         backgroundImage.classList.add('opacity-0');
      }
   }

   const determineWidth = () => {
      
      
      const spacerTop = spacer.offsetTop - headerHeight;
      const spacerHeight = spacer.offsetHeight - spacerTop;
      const scrollPosition = document.scrollingElement.scrollTop;

      const widthDifference = endingWidth - startingWidth;
      const yAxisCalculations = ((scrollPosition - spacerTop) / (spacerHeight - spacerTop));

      return (widthDifference * yAxisCalculations) + startingWidth;
   }

   const determineHeight = () => {
      const startingHeight = endingHeight / heightDivider;
      const spacerTop = spacer.offsetTop - headerHeight;
      const spacerHeight = spacer.offsetHeight - spacerTop;
      const scrollPosition = document.scrollingElement.scrollTop;

      const heightDifference = endingHeight - startingHeight;
      const yAxisCalculations = ((scrollPosition - spacerTop) / (spacerHeight - spacerTop));

      return (heightDifference * yAxisCalculations) + startingHeight;
   }

   const updateImageContainerState = () => {
      const imageContainer = el.previousElementSibling;
      const imageContainerPosition = imageContainer.getBoundingClientRect();
      if (imageContainerPosition.top <= (headerHeight + headerHeight - screenHeight)) {
         imageWindow.style.width = `${endingWidth}${widthUnit}`;
         imageWindow.style.height = `100%`;
      } else if (imageContainerPosition.top >= 97) {
         imageWindow.style.width = `${startingWidth}${widthUnit}`;
         imageWindow.style.height = `${endingHeight / heightDivider}%`;
      } else {
         imageWindow.style.width = `${determineWidth()}${widthUnit}`;
         imageWindow.style.height = `${determineHeight()}%`;
      }
   }

   const scrollSnap = () => {
      const mainContent = el.querySelector('[data-book-heading-final-content]');
      const elementTopPostition = getElemDistance(mainContent);
      const html = document.querySelector('html');
      html.style.scrollBehavior = 'auto';

      $('html, body').animate({
         scrollTop: elementTopPostition
      }, 3000);

      setTimeout(() => {
         html.style.scrollBehavior = 'smooth';
      }, 3500);
   }

   var getElemDistance = function ( elem ) {
      var location = 0;
      if (elem.offsetParent) {
         do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
         } while (elem);
      }
      return location >= 0 ? location : 0;
   };

   let runScrollSnap = true;
   updateBackgroundState();
   updateImageContainerState();
   window.onscroll = function(){
      updateBackgroundState();
      updateImageContainerState();
   };
   if (document.scrollingElement.scrollTop === 0) {
      setTimeout(() => {
         if (document.scrollingElement.scrollTop === 0) {
            scrollSnap();
            runScrollSnap = false;
         }
      }, 2000);
   }
   addEventListener("scrollend", (event) => {
      const scrollPosition = document.scrollingElement.scrollTop;
      const mainContent = el.querySelector('[data-book-heading-final-content]');
      const elementTopPostition = getElemDistance(mainContent);
      if (runScrollSnap) {
         if (scrollPosition < elementTopPostition) {
            scrollSnap();
         }
         runScrollSnap = false;
      }
   });

   let bookHeadingParallaxTimeout;
   window.onresize = function(){
      clearTimeout(bookHeadingParallaxTimeout);
      const runCodeOnResize = () => {
         updateBackgroundState();
         updateImageContainerState();
      }
      bookHeadingParallaxTimeout = setTimeout(runCodeOnResize, 100);
   };
}

export default bookHeadingParallax;